"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCarousel = useCarousel;
var _react = require("react");
var _base = require("@site/pattern-library-utils/base.functions");
/**
 * Custom hook to add carousel functionality to a component
 * @param {Object} options Configuration options for the carousel
 * @param {number} options.scrollAmount Amount in pixels to scroll per navigation action
 * @param {boolean} options.enableKeyboardNavigation Whether to enable keyboard navigation
 * @param {Object} options.keyBindings Custom key bindings for navigation
 * @returns {Object} Refs and navigation functions for the carousel
 */
function useCarousel({
  scrollAmount,
  enableKeyboardNavigation = true,
  keyBindings = {
    next: 'ArrowRight',
    prev: 'ArrowLeft'
  }
} = {}) {
  const carouselRef = (0, _react.useRef)(null);
  const cardRef = (0, _react.useRef)(null);
  const cardWidth = (0, _base.useWidthObserver)(cardRef);
  const effectiveScrollAmount = scrollAmount || cardWidth;
  const next = (0, _react.useCallback)(() => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: effectiveScrollAmount,
        behavior: 'smooth'
      });
    }
  }, [effectiveScrollAmount]);
  const prev = (0, _react.useCallback)(() => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: -effectiveScrollAmount,
        behavior: 'smooth'
      });
    }
  }, [effectiveScrollAmount]);
  (0, _react.useEffect)(() => {
    if (!enableKeyboardNavigation) return;
    const carouselElement = carouselRef.current;
    if (!carouselElement) return;
    const handleKeyDown = event => {
      if (event.key === keyBindings.next) {
        return next();
      } else if (event.key === keyBindings.prev) {
        return prev();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [enableKeyboardNavigation, keyBindings, next, prev]);
  return {
    carouselRef,
    cardRef,
    next,
    prev
  };
}